import styled from "styled-components";
import { colors } from "../../components/helpers/functions";

export const BoxContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: rgba(${colors.marron_tierra}, 1);
    .container{
        width: 100%;
    }
    .header{
        width: 100%;
        img{
            float: left;
            width: 100%;
        }
    }
    .video_bienvenida{
        display: flex;
        video{
            width: 100%;
            float: left;
        }
    }
    .box{
        width: 100%;
        .inner{
            display: flex;
            flex-direction: column;
            padding: 10vw 8vw;
            .title{
                font-size: 6.5vw;
                font-weight: 800;
                margin-bottom: 4.5vw;
                .mercado_rural{
                    font-size: 8.5vw;
                    font-weight: 800;
                }
            }
            .description{
                font-size: 3.7vw;
                line-height: 5.2vw;
                font-weight: 500;
                
                //margin-bottom: 30px;
            }
        }
        .image{
            width: 100%;
            img{
                float: left;
                width: 100%;
            }
        }
    }

    .back_marron_tierra{
        background-color: rgba(${colors.marron_tierra}, 1);
    }
    .back_verde_brocoli{
        background-color: rgba(${colors.verde_brocoli}, 1);
    }
    .back_verde_acelga{
        background-color: rgba(${colors.verde_acelga}, 1);
    }
    .back_azul_agua{
        background-color: rgba(${colors.azul_agua}, 1);
    }
    .back_naranja_pimiento{
        background-color: rgba(${colors.naranja_pimiento}, 1);
    }
    .back_amarillo_banana{
        background-color: rgba(${colors.amarillo_banana}, 1);
    }
    .back_blanco_huevo{
        background-color: rgba(${colors.blanco_huevo}, 1);
    }
    .back_trebol{
        background-color: rgba(${colors.trebol}, 1);
    }

    .text_marron_tierra{
        color: rgba(${colors.marron_tierra}, 1);
    }
    .text_verde_brocoli{
        color: rgba(${colors.verde_brocoli}, 1);
    }
    .text_verde_acelga{
        color: rgba(${colors.verde_acelga}, 1);
    }
    .text_azul_agua{
        color: rgba(${colors.azul_agua}, 1);
    }
    .text_naranja_pimiento{
        color: rgba(${colors.naranja_pimiento}, 1);
    }
    .text_amarillo_banana{
        color: rgba(${colors.amarillo_banana}, 1);
    }
    .text_blanco_huevo{
        color: rgba(${colors.blanco_huevo}, 1);
    }
    .text_trebol{
        color: rgba(${colors.trebol}, 1);
    }
    .wp_contact_float{
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 60px;
        height: 60px;
        background-color: #25D366;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        cursor: pointer;
        z-index: 1000;
        .wp_icon_float{
            display: flex;
            color: #FFFFFF;
            font-size: 32px;
        }
    }
    
    @media (max-width: 480px) {
        /* Mobile styles */
    }

    @media (min-width: 481px) and (max-width: 768px) {
        /* Tablet styles */
    }

    @media (min-width: 769px) and (max-width: 1024px) {
        /* Desktop small styles */
    }

    @media (min-width: 1025px) and (max-width: 1200px) {
        /* Desktop medium styles */
    }

    @media (min-width: 1201px) {
        /* Desktop large styles */
        display: flex;
        flex-direction: column;
        align-items: center;
        .container{
            max-width: 1100px;
        }

        .box{
            width: 100%;
            .inner{
                display: flex;
                flex-direction: column;
                padding: 20px 10px;
                .title{
                    font-size: 35px;
                    font-weight: 800;
                    margin-bottom: 30px;
                    .mercado_rural{
                        font-size: 35px;
                        font-weight: 800;
                    }
                }
                .description{
                    font-size: 20px;
                    line-height: 28px;
                    font-weight: 500;
                    
                    //margin-bottom: 30px;
                }
            }
            .image{
                width: 100%;
                img{
                    float: left;
                    width: 100%;
                }
            }
        }
    }

`